import { useEffect, useState } from "react";

// Searchable franchisee list — mirrors the shadow-day host picker in
// ContactsPage (Interested checklist).
export function FranchiseeTrainerPicker({ franchisees, selectedId, selectedName, onSelect, testid }) {
  const [query, setQuery] = useState("");
  const label = (f) => {
    const name = [f.first_name, f.last_name].filter(Boolean).join(" ").trim() || f.organisation || f.mojo_email || f.id;
    return `${name}${f.franchise_number ? ` · #${f.franchise_number}` : ""}${f.city ? ` · ${f.city}` : ""}`;
  };
  const sel = franchisees.find((f) => f.id === selectedId);
  const q = query.trim().toLowerCase();
  const shown = franchisees.filter((f) => !q || [f.first_name, f.last_name, f.organisation, f.franchise_number, f.mojo_email, f.city, f.postcode]
    .filter(Boolean).join(" ").toLowerCase().includes(q));
  return (
    <div className="mt-2" data-testid={testid}>
      <div className="mb-1.5 text-xs" data-testid={`${testid}-selected`}>
        {selectedId
          ? <span className="inline-flex items-center gap-2 px-2.5 py-1 rounded-md bg-stone-950 text-[#dddd16] font-semibold">Trainer: {sel ? label(sel) : (selectedName || selectedId)}</span>
          : <span className="text-stone-500">No franchisee selected yet.</span>}
      </div>
      <input
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search active franchisees…"
        data-testid={`${testid}-search`}
        className="w-full mb-1 px-3 py-1.5 bg-white border border-stone-300 rounded-lg text-sm focus:outline-none focus:border-stone-900"
      />
      <div role="listbox" data-testid={`${testid}-list`} className="w-full max-h-44 overflow-y-auto bg-white border border-stone-200 rounded-lg divide-y divide-stone-100">
        {franchisees.length === 0 && <div className="px-3 py-2 text-sm text-stone-400">Loading active franchisees…</div>}
        {shown.map((f) => (
          <button
            key={f.id}
            type="button"
            role="option"
            aria-selected={f.id === selectedId}
            onClick={() => onSelect(f.id, label(f))}
            data-testid={`${testid}-option-${f.id}`}
            className={`block w-full text-left px-3 py-1.5 text-sm transition-colors ${f.id === selectedId ? "bg-stone-950 text-white font-semibold" : "text-stone-900 hover:bg-stone-50"}`}
          >
            {label(f)}
          </button>
        ))}
      </div>
    </div>
  );
}

export function useActiveFranchisees(api, enabled) {
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!enabled || list.length) return;
    (async () => {
      try {
        const { data } = await api.get("/franchisees", { params: { limit: 500 } });
        const all = Array.isArray(data) ? data : (data?.franchisees || data?.items || []);
        const hasTag = (f, t) => (Array.isArray(f.tags) ? f.tags.includes(t) : f.tags === t);
        setList(all.filter((f) => hasTag(f, "Franchisee") && !hasTag(f, "Demo") && !hasTag(f, "HQ")));
      } catch { /* leave empty */ }
    })();
  }, [api, enabled, list.length]);
  return list;
}
